import { ObjectID } from 'bson';
import _ from 'lodash';
import { fallbackLanguage } from '../constants';
import { LanguageKeys } from '../schemas/localized-text';
import { ITag, ITagDocument, ITagSingleLang, localizedFields } from '../schemas/tag-as-model';

export function toSingleLangTag(tag: Pick<ITag, 'names'>, lang: LanguageKeys): ITagSingleLang {
  if (typeof (tag as ITagDocument).toObject === 'function') {
    throw new Error('tag object can not be a mongoose document, it has to be a POJO');
  }
  const clonedTag = _.cloneDeep(tag);
  for (const fieldKey of localizedFields) {
    const localizedValue = _.get(clonedTag, fieldKey);
    if (!localizedValue) continue;
    if (_.isObject(localizedValue)) {
      _.set(clonedTag, fieldKey, localizedValue[lang] || localizedValue[fallbackLanguage]);
    }
  }
  return (clonedTag as unknown) as ITagSingleLang;
}

export function toSingleLangTagsFrom(tags: ObjectID[] | ITag[], lang: LanguageKeys) {
  if (!tags || !_.isArray(tags) || !tags[0]) return tags;

  if (areTagIds(tags)) return tags;

  for (const tag of tags) {
    if (tag && tag.names && _.isObject(tag.names)) {
      const localizedValue = tag.names;
      _.set(tag, 'names', localizedValue[lang] || localizedValue[fallbackLanguage]);
    }
  }
  return tags;
}

export function areTagIds(tags: ObjectID[] | ITag[]): tags is ObjectID[] {
  if (!tags || !_.isArray(tags)) return false;
  if (!tags[0]) return true;
  return tags[0] instanceof ObjectID || typeof tags[0] === 'string';
}
